import script from "./order-receive-table.vue?vue&type=script&setup=true&lang=js"
export * from "./order-receive-table.vue?vue&type=script&setup=true&lang=js"

import "./order-receive-table.vue?vue&type=style&index=0&id=85399502&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85399502"]])

export default __exports__